import React from 'react';
import { Shield, UserCheck, TrendingUp, Bot, MapPin, DollarSign, BarChart3 } from 'lucide-react';

const ITEMS = [
  { icon: UserCheck, title: 'Dedicated Dispatcher', desc: 'You get one dedicated dispatcher who knows your truck and goals — not a rotating call center.' },
  { icon: Shield, title: 'Broker Credit Verified', desc: 'We verify broker credit and payment history before every booking, so you always get paid.' },
  { icon: TrendingUp, title: 'Revenue Optimization', desc: 'Data-backed rate negotiation and smart lane planning to maximize your revenue per mile.' },
  { icon: Bot, title: 'AI-Powered Communication', desc: 'Fast, responsive updates and follow-ups powered by smart automation working around the clock.' },
  { icon: MapPin, title: 'Real-Time Tracking', desc: 'Always know where your loads stand with real-time shipment visibility and status updates.' },
  { icon: DollarSign, title: 'Transparent Pricing', desc: 'Simple, flat dispatch fees with no hidden charges and no long-term lock-in contracts.' },
  { icon: BarChart3, title: 'Performance Reporting', desc: 'Clear analytics on RPM, loaded vs. empty miles, and revenue so you can grow with confidence.' },
];

export const Differentiators = () => (
  <section className="py-20 bg-gray-900" data-testid="differentiators">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <span className="inline-block bg-orange-600 text-white rounded-full px-4 py-1.5 text-sm font-semibold mb-4">The Flow Fleet Difference</span>
        <h2 className="text-4xl font-bold text-white mb-4">Not Your Average Dispatch Company</h2>
        <p className="text-lg text-gray-300 max-w-3xl mx-auto">
          Most dispatchers sound the same. We deliver measurable value you can actually see in your settlements.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {ITEMS.map((it, i) => (
          <div key={i} className="bg-gray-800 rounded-2xl p-7 border border-gray-700 hover:border-orange-500 transition-all" data-testid={`differentiator-${i}`}>
            <div className="w-12 h-12 bg-orange-600/20 rounded-xl flex items-center justify-center mb-4">
              <it.icon className="h-6 w-6 text-orange-400" />
            </div>
            <h3 className="text-lg font-bold text-white mb-2">{it.title}</h3>
            <p className="text-gray-400 text-sm leading-relaxed">{it.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
